/**
 * Static options for property availability settings
 */

export const HOURS_OPTIONS = [
  // Hours 1-24
  ...Array.from({ length: 24 }, (_, i) => ({
    value: String(i + 1),
    label: `${i + 1}`,
  })),
  // Multiples of 24: 48, 72, 168
  { value: "48", label: "48" },
  { value: "72", label: "72" },
  { value: "168", label: "168" },
];

export const PREPARATION_TIME_OPTIONS = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
];

/**
 * Generate days options with translations
 * @param t - Translation function
 * @returns Array of day options
 */
export const generateDaysOptions = (t: (key: string) => string) => [
  { value: "-1", label: t("AVAILABILITY_SETTINGS.ALL_DATES_AVAILABLE") },
  ...Array.from({ length: 14 }, (_, i) => ({
    value: String((i + 1) * 30),
    label: `${(i + 1) * 30}`,
  })),
];

/**
 * Generate days of the week options with translations
 * @param t - Translation function
 * @returns Array of days of the week with translations
 */
export const generateDaysOfWeekOptions = (t: (key: string) => string) => [
  { key: "monday", label: t("AVAILABILITY_SETTINGS.MONDAY"), index: 0 },
  { key: "tuesday", label: t("AVAILABILITY_SETTINGS.TUESDAY"), index: 1 },
  { key: "wednesday", label: t("AVAILABILITY_SETTINGS.WEDNESDAY"), index: 2 },
  { key: "thursday", label: t("AVAILABILITY_SETTINGS.THURSDAY"), index: 3 },
  { key: "friday", label: t("AVAILABILITY_SETTINGS.FRIDAY"), index: 4 },
  { key: "saturday", label: t("AVAILABILITY_SETTINGS.SATURDAY"), index: 5 },
  { key: "sunday", label: t("AVAILABILITY_SETTINGS.SUNDAY"), index: 6 },
];
